import { Helmet } from "react-helmet";
export default function MobileAppDevelopmentPage() {
  return (
    <div className="bg-[#0a0d1f] text-white overflow-hidden">

      
  <Helmet>

    {/* BASIC SEO */}
    <title>
      Mobile App Development Company | Android & iOS App Development | SoftCoders
    </title>

    <meta
      name="description"
      content="SoftCoders is a mobile app development company providing Android app development, iOS app development, Flutter apps, React Native apps, custom mobile applications, UI/UX design, and scalable app solutions for startups and businesses."
    />

    <meta
      name="keywords"
      content="
      mobile app development company,
      android app development company,
      ios app development company,
      react native app development,
      flutter app development,
      mobile application development services,
      custom mobile app development,
      app development company india,
      cross platform app development,
      native mobile app development,
      startup app development,
      ecommerce mobile app,
      healthcare app development,
      fintech app development,
      mobile ui ux design,
      software company india,
      mobile app developers,
      app development agency,
      hybrid mobile apps,
      ios and android apps,
      mobile software development,
      scalable mobile apps,
      mobile app solutions,
      enterprise mobile apps,
      business mobile applications,
      mobile app development services india,
      mobile development agency,
      react native developers,
      flutter developers,
      mobile app design company
      "
    />

    <meta name="author" content="SoftCoders" />
    <meta name="robots" content="index, follow" />
    <meta name="language" content="English" />
    <meta name="revisit-after" content="2 days" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://softcoders.in/mobile-app-development"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Mobile App Development Company | SoftCoders"
    />

    <meta
      property="og:description"
      content="Professional Android & iOS app development services with Flutter, React Native, and scalable mobile app solutions."
    />

    <meta
      property="og:url"
      content="https://softcoders.in/mobile-app-development"
    />

    <meta property="og:type" content="website" />

    <meta
      property="og:image"
      content="https://softcoders.in/og-mobile-app-development.jpg"
    />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />

    <meta
      name="twitter:title"
      content="Mobile App Development Company | SoftCoders"
    />

    <meta
      name="twitter:description"
      content="Android, iOS, Flutter, and React Native app development services for startups and enterprises."
    />

    <meta
      name="twitter:image"
      content="https://softcoders.in/og-mobile-app-development.jpg"
    />

    {/* GEO */}
    <meta name="geo.region" content="IN" />
    <meta name="geo.country" content="India" />

    {/* SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareCompany",
        name: "SoftCoders",
        url: "https://softcoders.in",
        logo: "https://softcoders.in/logo.png",
        description:
          "SoftCoders provides Android app development, iOS app development, Flutter app development, React Native development, and custom mobile application solutions.",
        address: {
          "@type": "PostalAddress",
          addressCountry: "India",
        },
        sameAs: [
          "https://www.facebook.com/",
          "https://www.instagram.com/",
          "https://www.linkedin.com/"
        ],
        service: [
          {
            "@type": "Service",
            name: "Android App Development"
          },
          {
            "@type": "Service",
            name: "iOS App Development"
          },
          {
            "@type": "Service",
            name: "Flutter App Development"
          },
          {
            "@type": "Service",
            name: "React Native Development"
          }
        ]
      })}
    </script>

  </Helmet>

      {/* ─── HERO — split diagonal ─── */}
      <section className="relative min-h-screen flex items-center px-6 lg:px-20 overflow-hidden">

        {/* diagonal bg slice */}
        <div className="absolute inset-0 z-0">
          <div className="absolute right-0 top-0 w-[55%] h-full bg-[#12163a] clip-diagonal" style={{clipPath:"polygon(12% 0, 100% 0, 100% 100%, 0% 100%)"}}></div>
        </div>

        {/* glow orbs */}
        <div className="absolute top-20 right-[15%] w-[380px] h-[380px] rounded-full bg-[#6b5ce7]/15 blur-[100px] pointer-events-none z-0"></div>
        <div className="absolute bottom-20 left-[5%] w-[280px] h-[280px] rounded-full bg-[#2d3fb5]/15 blur-[80px] pointer-events-none z-0"></div>

        <div className="relative z-10 max-w-7xl w-full grid lg:grid-cols-2 gap-20 items-center py-24">

          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 border border-[#6b5ce7]/40 bg-[#6b5ce7]/10 px-4 py-2 rounded-full text-[#b8a9f8] text-sm mb-8">
              <span className="w-2 h-2 bg-[#6b5ce7] rounded-full animate-pulse"></span>
              iOS & Android Specialists
            </div>

            <h1 className="text-5xl md:text-[68px] font-black leading-[1.0] tracking-tight">
              Mobile App
              <span className="block mt-1" style={{WebkitTextStroke:"2px #4a5fd4", color:"transparent"}}>
                Development
              </span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#6b5ce7] via-[#4a5fd4] to-[#8fa3f8] mt-1">
                That Converts.
              </span>
            </h1>

            <p className="mt-8 text-[#9aa3c2] text-lg leading-8 max-w-xl">
              SoftCoders crafts high-performance native and cross-platform mobile apps
              for iOS and Android. Beautiful UI, lightning-fast performance,
              and features that users love.
            </p>

            {/* pill tags */}
            <div className="flex flex-wrap gap-3 mt-8">
              {["React Native", "Flutter", "Swift", "Kotlin", "Expo"].map((t, i) => (
                <span key={i} className="px-4 py-1.5 rounded-full text-sm border border-[#4a5fd4]/40 text-[#8fa3f8] bg-[#1a2472]/20">
                  {t}
                </span>
              ))}
            </div>

            <div className="flex flex-wrap gap-4 mt-10">
               <a
    href="/contact"
className="px-8 py-4 rounded-2xl bg-gradient-to-r from-[#6b5ce7] to-[#2d3fb5] font-semibold text-lg hover:scale-105 transition duration-300 shadow-2xl shadow-[#6b5ce7]/30">
                Start Your App
              </a>

              <a
    href="/portfolio"
 className="px-8 py-4 rounded-2xl border border-white/20 hover:bg-white hover:text-black transition duration-300 text-lg">
                See Portfolio
              </a>
            </div>

            {/* stats row */}
            <div className="flex gap-10 mt-14 border-t border-white/10 pt-10">
              {[["200+","Apps Delivered"],["4.9★","Avg App Rating"],["50M+","Users Served"]].map(([v,l],i)=>(
                <div key={i}>
                  <div className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#6b5ce7] to-[#8fa3f8]">{v}</div>
                  <div className="text-[#9aa3c2] text-sm mt-1">{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — phone mockup stack */}
          <div className="relative flex justify-center items-center h-[600px]">
            {/* back phone */}
            <div className="absolute left-8 top-10 w-[220px] h-[440px] rounded-[36px] bg-[#1a2472]/60 border border-[#4a5fd4]/30 backdrop-blur-xl rotate-[-8deg] shadow-2xl overflow-hidden">
              <div className="h-6 bg-black/40 flex items-center justify-center mt-3 mx-3 rounded-full">
                <div className="w-16 h-1.5 bg-white/20 rounded-full"></div>
              </div>
              <div className="p-4 mt-4 space-y-3">
                <div className="h-28 rounded-2xl bg-gradient-to-br from-[#2d3fb5]/40 to-[#6b5ce7]/30 border border-[#4a5fd4]/20"></div>
                <div className="h-3 bg-white/10 rounded-full w-3/4"></div>
                <div className="h-3 bg-white/10 rounded-full w-1/2"></div>
                <div className="grid grid-cols-2 gap-2 mt-4">
                  <div className="h-16 rounded-xl bg-[#6b5ce7]/20 border border-[#6b5ce7]/20"></div>
                  <div className="h-16 rounded-xl bg-[#2d3fb5]/20 border border-[#2d3fb5]/20"></div>
                </div>
              </div>
            </div>

            {/* front phone — main */}
            <div className="relative w-[250px] h-[500px] rounded-[44px] bg-[#12163a] border border-[#4a5fd4]/50 shadow-2xl shadow-[#6b5ce7]/20 overflow-hidden z-10">
              {/* notch */}
              <div className="h-8 bg-black/60 flex items-center justify-center mt-3 mx-6 rounded-full">
                <div className="w-20 h-1.5 bg-white/20 rounded-full"></div>
              </div>
              {/* screen content */}
              <div className="p-5 space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs text-[#9aa3c2]">Dashboard</div>
                    <div className="text-base font-bold mt-0.5">Good morning 👋</div>
                  </div>
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#6b5ce7] to-[#2d3fb5]"></div>
                </div>

                <div className="p-4 rounded-2xl bg-gradient-to-br from-[#2d3fb5]/50 to-[#6b5ce7]/30 border border-[#4a5fd4]/30">
                  <div className="text-xs text-[#9aa3c2]">Revenue Today</div>
                  <div className="text-2xl font-black text-white mt-1">$24,830</div>
                  <div className="text-xs text-green-400 mt-1">↑ 18.4% vs yesterday</div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  {[["Orders","142","↑"],["Users","2.4k","↑"]].map(([l,v,a],i)=>(
                    <div key={i} className="p-3 rounded-xl bg-[#1a2472]/60 border border-[#4a5fd4]/20">
                      <div className="text-xs text-[#9aa3c2]">{l}</div>
                      <div className="text-lg font-black">{v}</div>
                      <div className="text-xs text-green-400">{a}</div>
                    </div>
                  ))}
                </div>

                {/* mini chart bars */}
                <div className="flex items-end gap-1.5 h-16 px-1">
                  {[40,65,45,80,55,90,70].map((h,i)=>(
                    <div key={i} className="flex-1 rounded-t-sm" style={{height:`${h}%`, background: i===5 ? "linear-gradient(to top,#6b5ce7,#4a5fd4)" : "rgba(74,95,212,0.25)"}}></div>
                  ))}
                </div>

                {/* bottom nav */}
                <div className="flex justify-around pt-2 border-t border-white/10">
                  {["⊞","♡","🔔","◯"].map((ic,i)=>(
                    <div key={i} className={`text-lg ${i===0?"text-[#8fa3f8]":"text-white/30"}`}>{ic}</div>
                  ))}
                </div>
              </div>
            </div>

            {/* floating badge cards */}
            <div className="absolute top-6 right-4 bg-[#1a2472]/80 border border-[#4a5fd4]/40 backdrop-blur-xl rounded-2xl px-4 py-3 text-sm z-20 shadow-xl">
              <div className="text-[#9aa3c2] text-xs">App Store Rating</div>
              <div className="text-lg font-black text-[#8fa3f8]">4.9 ⭐</div>
            </div>
            <div className="absolute bottom-20 right-0 bg-[#1a2472]/80 border border-[#4a5fd4]/40 backdrop-blur-xl rounded-2xl px-4 py-3 text-sm z-20 shadow-xl">
              <div className="text-[#9aa3c2] text-xs">Downloads</div>
              <div className="text-lg font-black text-[#8fa3f8]">50M+</div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── SERVICES — horizontal scroll cards ─── */}
      <section className="py-28 px-6 lg:px-20 bg-[#0d1128]">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
            <div>
              <p className="text-[#6b5ce7] font-semibold tracking-widest text-sm uppercase mb-3">What We Build</p>
              <h2 className="text-5xl font-black leading-tight">
                Mobile App
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                  Solutions
                </span>
              </h2>
            </div>
            <p className="text-[#9aa3c2] max-w-md leading-7">
              From MVP to enterprise-grade apps — we build for performance, scale, and delight.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
            {[
              { icon:"📱", color:"from-[#6b5ce7] to-[#4a5fd4]", title:"iOS App Development", desc:"Native Swift & SwiftUI apps optimized for iPhone and iPad with premium performance and Apple guidelines compliance." },
              { icon:"🤖", color:"from-[#2d3fb5] to-[#4a5fd4]", title:"Android App Development", desc:"Kotlin & Jetpack Compose apps tailored for the Android ecosystem — from phones to tablets and foldables." },
              { icon:"⚡", color:"from-[#4a5fd4] to-[#6b5ce7]", title:"React Native / Flutter", desc:"One codebase, two platforms. Cross-platform apps with near-native performance and shared business logic." },
              { icon:"🛒", color:"from-[#6b5ce7] to-[#2d3fb5]", title:"E-Commerce Apps", desc:"Mobile storefronts with cart, checkout, push notifications, and payment gateway integration." },
              { icon:"🏥", color:"from-[#2d3fb5] to-[#6b5ce7]", title:"On-Demand & Booking", desc:"Uber-style, food delivery, healthcare, and appointment booking apps with real-time tracking." },
              { icon:"🔗", color:"from-[#4a5fd4] to-[#2d3fb5]", title:"API & Backend Integration", desc:"Robust REST/GraphQL APIs, Firebase, AWS Amplify, and third-party SDK integrations." },
            ].map((s, i) => (
              <div key={i} className="group relative rounded-[28px] overflow-hidden border border-[#4a5fd4]/20 hover:border-[#6b5ce7]/60 transition-all duration-500 hover:-translate-y-2 bg-[#12163a]">
                {/* top accent bar */}
                <div className={`h-1 w-full bg-gradient-to-r ${s.color}`}></div>
                <div className="p-8">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center text-2xl mb-6`}>
                    {s.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-3">{s.title}</h3>
                  <p className="text-[#9aa3c2] leading-7 text-sm">{s.desc}</p>
                  <div className="mt-6 flex items-center gap-2 text-[#8fa3f8] font-semibold text-sm group-hover:gap-4 transition-all duration-300">
                    Learn More <span>→</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PROCESS — timeline style ─── */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-20">
            <p className="text-[#6b5ce7] font-semibold tracking-widest text-sm uppercase mb-3">How We Work</p>
            <h2 className="text-5xl font-black">
              Our{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Process
              </span>
            </h2>
          </div>

          <div className="relative">
            {/* vertical line */}
            <div className="absolute left-[28px] top-0 bottom-0 w-px bg-gradient-to-b from-[#6b5ce7] via-[#4a5fd4] to-transparent hidden md:block"></div>

            <div className="space-y-8">
              {[
                { num:"01", title:"Discovery & Scoping", desc:"We map out your app idea — user flows, feature list, tech stack, timeline, and budget. You get a clear project blueprint before we write a single line of code." },
                { num:"02", title:"UI/UX Design & Prototyping", desc:"Figma prototypes with real app flows. Interactive mockups tested on actual devices so you see exactly how your app will feel before development starts." },
                { num:"03", title:"Agile Development", desc:"Two-week sprints with regular demo calls. Clean, well-documented code with CI/CD pipelines, automated testing, and weekly progress updates." },
                { num:"04", title:"QA & Device Testing", desc:"Tested across 20+ real devices and OS versions. Performance, security, accessibility, and crash testing before any build goes to a client." },
                { num:"05", title:"App Store Launch", desc:"We handle App Store & Play Store submission — screenshots, metadata, ASO optimization — and guide you through the approval process." },
                { num:"06", title:"Post-Launch Support", desc:"Monitoring, crash reporting, OS update compatibility, and feature iterations. We're your long-term mobile tech partner." },
              ].map((item, i) => (
                <div key={i} className="relative flex gap-8 items-start group">
                  {/* circle */}
                  <div className="w-14 h-14 flex-shrink-0 rounded-full bg-gradient-to-br from-[#2d3fb5] to-[#6b5ce7] flex items-center justify-center font-black text-sm z-10 group-hover:scale-110 transition duration-300">
                    {item.num}
                  </div>
                  {/* card */}
                  <div className="flex-1 p-6 rounded-2xl bg-[#12163a] border border-[#4a5fd4]/20 group-hover:border-[#6b5ce7]/50 transition duration-300 mb-2">
                    <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                    <p className="text-[#9aa3c2] leading-7 text-sm">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ─── TECH STACK — grid with icons ─── */}
      <section className="py-28 px-6 lg:px-20 bg-[#0d1128]">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <p className="text-[#6b5ce7] font-semibold tracking-widest text-sm uppercase mb-3">Technologies</p>
            <h2 className="text-5xl font-black leading-tight">
              Cutting-Edge
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Tech Stack
              </span>
            </h2>
            <p className="text-[#9aa3c2] mt-6 leading-8 text-lg">
              We use the most proven, high-performance technologies to build
              mobile apps that are fast, maintainable, and future-proof.
            </p>

            <div className="mt-10 space-y-4">
              {[
                { label:"React Native & Expo", pct:95 },
                { label:"Flutter & Dart", pct:88 },
                { label:"Swift & SwiftUI", pct:90 },
                { label:"Kotlin & Jetpack Compose", pct:85 },
              ].map((bar, i) => (
                <div key={i}>
                  <div className="flex justify-between text-sm mb-2">
                    <span className="text-white font-medium">{bar.label}</span>
                    <span className="text-[#8fa3f8]">{bar.pct}%</span>
                  </div>
                  <div className="h-2 rounded-full bg-white/10 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7]"
                      style={{width:`${bar.pct}%`}}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            {[
              { label:"React Native", sub:"Cross Platform" },
              { label:"Flutter", sub:"Google SDK" },
              { label:"Swift", sub:"iOS Native" },
              { label:"Kotlin", sub:"Android Native" },
              { label:"Firebase", sub:"Backend" },
              { label:"GraphQL", sub:"API Layer" },
              { label:"Redux", sub:"State Mgmt" },
              { label:"Stripe", sub:"Payments" },
              { label:"AWS", sub:"Cloud" },
            ].map((t, i) => (
              <div key={i} className="p-4 rounded-2xl bg-[#12163a] border border-[#4a5fd4]/20 hover:border-[#6b5ce7]/60 hover:-translate-y-1 transition duration-300 text-center">
                <div className="font-bold text-sm">{t.label}</div>
                <div className="text-[#9aa3c2] text-xs mt-1">{t.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── INDUSTRIES ─── */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-[#6b5ce7] font-semibold tracking-widest text-sm uppercase mb-3">Industries</p>
            <h2 className="text-5xl font-black">
              Apps for Every{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Industry
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { icon:"🏥", label:"Healthcare", desc:"Telemedicine, patient portals" },
              { icon:"🎓", label:"EdTech", desc:"LMS, e-learning apps" },
              { icon:"🛒", label:"Retail", desc:"Mobile commerce, loyalty" },
              { icon:"🚚", label:"Logistics", desc:"Tracking, fleet management" },
              { icon:"🏦", label:"Fintech", desc:"Wallets, banking apps" },
              { icon:"🍕", label:"Food Delivery", desc:"Restaurant & delivery apps" },
              { icon:"💪", label:"Fitness", desc:"Workout & wellness apps" },
              { icon:"🏠", label:"Real Estate", desc:"Property listing apps" },
            ].map((ind, i) => (
              <div key={i} className="group p-6 rounded-[24px] bg-[#12163a] border border-[#4a5fd4]/20 hover:border-[#6b5ce7]/60 hover:-translate-y-2 transition duration-300">
                <div className="text-3xl mb-3">{ind.icon}</div>
                <div className="font-bold text-sm">{ind.label}</div>
                <div className="text-[#9aa3c2] text-xs mt-1 leading-5">{ind.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CTA — full-width gradient banner ─── */}
      <section className="relative py-28 px-6 lg:px-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a2472] via-[#2d3fb5]/80 to-[#6b5ce7]/60"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMwLTkuOTQtOC4wNi0xOC0xOC0xOFYyYzcuNzMyIDAgMTQgNi4yNjggMTQgMTRoMnptLTIgMGgxNnYySDM0di0yem0tMTggMGgydjE2aC0yVjE4eiIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIvPjwvZz48L3N2Zz4=')] opacity-40"></div>

        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <p className="text-[#b8a9f8] font-semibold tracking-widest text-sm uppercase mb-4">Let's Build Together</p>
          <h2 className="text-5xl md:text-6xl font-black leading-tight">
            Your App Idea Deserves
            <span className="block text-white mt-1">
              World-Class Execution.
            </span>
          </h2>

          <p className="text-[#c5cde8] text-lg max-w-2xl mx-auto mt-8 leading-8">
            From concept to App Store — SoftCoders delivers mobile apps that users
            love and businesses rely on. Let's start with a free strategy call.
          </p>

          <div className="flex flex-wrap justify-center gap-5 mt-12">
             <a
    href="https://wa.me/919254147455?text=Hello%20SoftCoders%2C%20I%20want%20to%20discuss%20my%20project."
    target="_blank"
    rel="noopener noreferrer"
className="px-10 py-5 rounded-2xl bg-white text-[#1a2472] text-lg font-black hover:scale-105 transition duration-300 shadow-2xl">
  
              Book Free Strategy Call
            </a>
            <a
    href="/portfolio"
 className="px-10 py-5 rounded-2xl border border-white/40 text-white hover:bg-white/10 transition duration-300 text-lg font-semibold">
              View App Portfolio
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-10 mt-16">
            {[["200+","Apps Launched"],["4.9★","Client Rating"],["iOS + Android","Both Platforms"],["48hr","Response Time"]].map(([v,l],i)=>(
              <div key={i} className="text-center">
                <div className="text-2xl font-black text-white">{v}</div>
                <div className="text-[#b8a9f8] text-sm mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}